<template>
  <RF-Dialog
  :cpntStatus='statusGeral'
  :cpntLargura='"650px"'
  :cpntOnFecharDialog='regAteNovoAtendimentoFechar'>
    <template slot='titulo'>
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>
      Iniciar atendimento
    </template>

    <template slot='conteudo'>
      <div :data-time='time' v-if="[ '', null, undefined ].indexOf(formulario.field) === -1" class="sub-ger-con-sup-rf">
        <!-- <div class="mensagem">
          Para conectar com o SuporteRF é necessario informar o motivo da conexão.
        </div> -->
        
        <div class="campos" v-if="[ '', null, undefined ].indexOf(formulario.field) === -1">
          <template v-for="(campo, index) in formulario.field">
            <RF-Componente :key="index" :class='index'
              :data-time='time'
              :cpntTamanho='campo.tamanho'
              :cpntModelo='campo.tipo'
              :cpntStatus='campo.status'
              :cpntId='campo.id'
              :cpntClassDivfield='campo.classDivfield'
              :cpntNome='campo.nome'
              :cpntValue='campo.value'
              :cpntValueRef='campo.valueRef'
              :cpntOptions='campo.options'
              :cpntKeyValue='campo.keyValue'
              :cpntKeyMostra='campo.keyMostra'
              :cpntSearchMinimo='campo.searchMinimo'
              :cpntAutoComplete='campo.autocomplete'
              :cpntDisabled='campo.disabled'
              :cpntMostrar='campo.mostrar'
              :cpntMensagem='campo.mensagem'
              :cpntSelecioneNome='campo.selecioneNome'
              :cpntSelecioneValue='campo.selecioneValue'
              :cpntMensagemTipo='campo.mensagemTipo'
              :cpntAdicinarOption='campo.adicinarOption'
              :cpntMultiple='campo.multiple'
              :cpntAllRegistro='campo.allRegistro'
              :cpntExplica='campo.explica'
              :cpntTabIndex='campo.tabIndex'
              :cpntOptionInicialNome='campo.optionInicialNome'
              :cpntOptionInicialValue='campo.optionInicialValue'

              :cpntRouter='campo.router'
              :cpntMethod='campo.method'
              :cpntField='campo.field'
              :cpntWhere='campo.where'

              :cpntOnKeyPressEnter='campo.onKeyPressEnter'
              :cpntOnChange='campo.onChange'
              :cpntOnBlur='campo.onBlur'
              :ref='index'
            ></RF-Componente>
          </template>
        </div>

        <div class="buttons">
          <RF-Button :key="index" v-for='(button, index) in formulario.buttons'
            :data-time='time'

            :cpntStatus='button.status' 
            :cpntId='button.id' 
            :cpntTexto='button.texto' 
            :cpntClass='button.class'
            :cpntMostrar='button.mostrar'
            :cpntTabIndex='button.tabIndex'

            @onClickButton='button.onClick'
          ></RF-Button>
        </div>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .sub-ger-con-sup-rf > .mensagem {
    text-align: center;
    text-decoration: underline;
  }
    .sub-ger-con-sup-rf > .mensagem > svg {
      margin: 0px 5px;
    }

  .sub-ger-con-sup-rf > .campos {
    padding-top: 25px;
    width: 535px;
    margin: 0px auto;
    text-align: center;
  }
    .sub-ger-con-sup-rf > .campos > .motivo,
    .sub-ger-con-sup-rf > .campos > .forma,
    .sub-ger-con-sup-rf > .campos > .responsavel,
    .sub-ger-con-sup-rf > .campos > .status {
      padding-top: 25px;
    }

  .sub-ger-con-sup-rf > .buttons {
    text-align: center;
  }
    .sub-ger-con-sup-rf > .buttons > button {
      margin: 15px 5px 0px 5px;
    }
</style>

<style>
  .sub-ger-con-sup-rf > .campos > div {
    display: inline-block;
    margin: 0px 5px;
  }
  .sub-ger-con-sup-rf > .campos > .codigo > div {
    width: 80px;
    max-width: 80px;
  }
  .sub-ger-con-sup-rf > .campos > .documento > div {
    width: 142px;
    max-width: 142px;
  }
  .sub-ger-con-sup-rf > .campos > .cliente > div {
    width: 280px;
    max-width: 280px;
  }
    .sub-ger-con-sup-rf > .campos > .cliente > div > ul {
      position: fixed;
    }
  .sub-ger-con-sup-rf > .campos > .motivo > div {
    width: 524px;
    max-width: 524px;
  }
  .sub-ger-con-sup-rf > .campos > .forma > div,
  .sub-ger-con-sup-rf > .campos > .responsavel > div,
  .sub-ger-con-sup-rf > .campos > .status > div {
    width: 168px;
    max-width: 168px;
  }

    .sub-ger-con-sup-rf > .campos > .codigo > div > input,
    .sub-ger-con-sup-rf > .campos > .documento > div > input {
      text-align: center;
    }
    .sub-ger-con-sup-rf > .campos > .codigo > div > input,
    .sub-ger-con-sup-rf > .campos > .documento > div > input,
    .sub-ger-con-sup-rf > .campos > .cliente > div > input,
    .sub-ger-con-sup-rf > .campos > .motivo > div > textarea {
      border-radius: 5px;
      border: 1px solid #ccc;
    }
    .sub-ger-con-sup-rf > .campos > .codigo > div > input ~ label,
    .sub-ger-con-sup-rf > .campos > .documento > div > input ~ label,
    .sub-ger-con-sup-rf > .campos > .cliente > div > input ~ label,
    .sub-ger-con-sup-rf > .campos > .motivo > div > textarea ~ label,
    
    .sub-ger-con-sup-rf > .campos > .forma > div > div > .select2 ~ label,
    .sub-ger-con-sup-rf > .campos > .responsavel > div > div > .select2 ~ label,
    .sub-ger-con-sup-rf > .campos > .status > div > div > .select2 ~ label {
      top: -17px;
      width: 100%;
      text-align: center;
    }
</style>

<script>
  export default {
    props: {
      cpntContatoId: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntAssuntoId: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntClu: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        formulario: {}
      }
    },
    mounted: function () {
      if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 29 ], null, [ 53 ], null, [ 569 ], null, false) === true) {
        this.regAteNovoAtendimentoIniciar()
      }
    },
    methods: {
      regAteNovoAtendimentoIniciar: function () {
        var self = this

        // SETA O STATUS DA TELA
        this.regAteNovoAtendimentoSetarStatusGeral('carregando')

        // IMPORTA A FUNÇÃO PARA ATUAIZAR OS DADOS DA API
        const FUN_TRATAR_RETONOS_E_CALLBACK = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_RETONOS_E_CALLBACK

        // EXECUTA A FUNÇÃO DE CALLBACKS
        FUN_TRATAR_RETONOS_E_CALLBACK(self, {
          regAteNovoAtendimentoCamposIniciar: [ ],
          regAteNovoAtendimentoBuscaFormaContato: [ ],
          regAteNovoAtendimentoBuscarResponsavel: [ ],
          regAteNovoAtendimentoBuscarStatus: [ ],
          regAteNovoAtendimentoBuscarDados: [ 'regAteNovoAtendimentoCamposIniciar', 'regAteNovoAtendimentoBuscaFormaContato', 'regAteNovoAtendimentoBuscarResponsavel', 'regAteNovoAtendimentoBuscarStatus' ],
          regAteNovoAtendimentoFinalizar: [ 'regAteNovoAtendimentoBuscarDados' ]
        },
        {
          regAteNovoAtendimentoCamposIniciar: function (chave, callback, self) { self.regAteNovoAtendimentoCamposIniciar(self, function () { callback(chave) } ) },
          regAteNovoAtendimentoBuscaFormaContato: function (chave, callback, self) { self.regAteNovoAtendimentoBuscaFormaContato(self, function () { callback(chave) } ) },
          regAteNovoAtendimentoBuscarResponsavel: function (chave, callback, self) { self.regAteNovoAtendimentoBuscarResponsavel(self, function () { callback(chave) } ) },
          regAteNovoAtendimentoBuscarStatus: function (chave, callback, self) { self.regAteNovoAtendimentoBuscarStatus(self, function () { callback(chave) } ) },
          regAteNovoAtendimentoBuscarDados: function (chave, callback, self) { self.regAteNovoAtendimentoBuscarDados(self, function () { callback(chave) } ) },
          regAteNovoAtendimentoFinalizar: function (chave, callback, self) { self.regAteNovoAtendimentoFinalizar(self, function () { callback(chave) } ) },
        })
      },
      regAteNovoAtendimentoFechar: function (atualizar, id = false, dados = {}) {
        this.cpntFecharFormulario(atualizar, id, dados)
      },
      regAteNovoAtendimentoSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteNovoAtendimentoCamposIniciar: function (self, callback = null) {
        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario = {
          status: 'carregando',
          id: 'sub-ger-sup-rf-',
          field: {},
          buttons: {},
          tabIndexfieldGeral: 70001,
          tabIndexButtonGeral: 70002
        }

        self.formulario.field.codigo = {
          status: '',
          tipo: 'input',
          id: self.formulario.id + '-codigo',
          tamanho: 51,
          nome: 'CLU',
          apiRec: 'clu',
          value: '',
          onChange: self.regAteNovoAtendimentoOnChange,
          onKeyPressEnter: self.regAteNovoAtendimentoBuscaAtravesDosDadosDigitados,
          onBlur: function (id) {
            if (isNaN(self.formulario.field.codigo.value) === false && self.formulario.field.codigo.value.length === 4) {
              self.regAteNovoAtendimentoBuscaAtravesDosDadosDigitados(id)
            }
          }
        }

        // SETA O CAMPO STATUS
        self.formulario.field.documento = {
          status: '',
          tipo: 'input',
          id: self.formulario.id + '-documento',
          tamanho: 51,
          nome: '',
          mask: 'cnpj',
          apiRec: 'cnpj',
          value: '',
          onChange: self.regAteNovoAtendimentoOnChange,
          onKeyPressEnter: self.regAteNovoAtendimentoBuscaAtravesDosDadosDigitados
        }

        // SETA O CAMPO STATUS
        self.formulario.field.cliente = {
          status: '',
          tipo: 'auto-complite',
          id: self.formulario.id + '-cliente',
          tamanho: 51,
          nome: 'Cliente',
          value: '',
          valueRef: '',
          apiRec: 'cliente',
          apiRef: 'id',
          router: '/contato/get',
          method: 'POST',
          field: { id: null, nome: { a: 'cliente' }, empresa: null, cnpj_cpf: { a: 'cnpj' }, pessoa: null },
          where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'contato', o: 's.ft', v: '' } ] },
          keyMostra: [ 'cliente', ' | ', 'empresa', ' | ', 'cnpj' ],
          onChange: self.regAteNovoAtendimentoOnChange,
          onRealizaBusca: function () {
            // LIMPA O CAMPO SELECIONADO
            self.formulario.field.cliente.valueRef = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }
        }

        // SETA O CAMPO STATUS
        self.formulario.field.motivo = {
          status: '',
          tipo: 'textarea',
          id: self.formulario.id + '-motivo',
          tamanho: 51,
          nome: 'Motivo',
          value: '',
          apiEnv: 'comentario',
          onChange: self.regAteNovoAtendimentoOnChange
        }

        // SETA O CAMPO STATUS
        self.formulario.field.forma = {
          status: '',
          tipo: 'select2',
          id: self.formulario.id + '-forma',
          tamanho: 3,
          nome: 'Forma de contato',
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          value: '',
          apiEnv: 'id_forma_contato',
          onChange: self.regAteNovoAtendimentoOnChange
        }

        // SETA O CAMPO RESPONSAVEL
        self.formulario.field.responsavel = {
          status: '',
          tipo: 'select2',
          id: self.formulario.id + '-responsavel',
          tamanho: 3,
          nome: 'Responsável',
          keyValue: 'id',
          keyMostra: [ 'usuario' ],
          // value: self.$store.state.usuario.id_usu,
          optionInicialNome: '',
          apiEnv: 'responsavel_user',
          onChange: self.regAteNovoAtendimentoOnChange
        }

        // SETA O CAMPO STATUS
        self.formulario.field.status = {
          status: '',
          tipo: 'select2',
          id: self.formulario.id + '-status',
          tamanho: 3,
          nome: 'Status',
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          optionInicialNome: '',
          apiEnv: 'id_status',
          onChange: self.regAteNovoAtendimentoOnChange
        }

        // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
        self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario.field, function (fields) {
          // SETA OS CAMPOS RECEBIDOS
          self.formulario.field = fields

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA CRIAR OS BUTTONS
          self.$store.state.FUN_CREATE_BUTTON_FORM(self.formulario.id, [ 0 ], null, {
            atendimento: self.regAteNovoAtendimentoSalvarComentario,
            direto: self.regAteNovoAtendimentoSalvarComentario,
            link: self.regAteNovoAtendimentoSalvarComentario
          }, function (buttons) {
            // SETA O TITULO DO BOTÃO
            buttons.atendimento.texto = 'Iniciar Atendimento'
            buttons.atendimento.class = [ 'btn', 'btn-primary', 'btn-sm' ]
            buttons.direto.texto = 'Conectar Diretamente'
            buttons.direto.class = [ 'btn', 'btn-primary', 'btn-sm' ]
            buttons.link.texto = 'Copiar Link de Acesso'
            buttons.link.class = [ 'btn', 'btn-primary', 'btn-sm' ]

            // CRIA OS BUTTONS DO FORMULARIO
            self.formulario.buttons = buttons

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // EXECUTA A FUNÇÃO CALLBACK 
            if (callback !== null) {
              callback()
            }
          })
        })
      },
      regAteNovoAtendimentoOnChange: function (value, id) {
        // PEGA O CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // SETA O VALOR RECEBIDO
        this.formulario.field[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.formulario.field[index].mensagem = ''
        this.formulario.field[index].mensagemTipo = ''

        switch (index) {
          case 'cliente':
            var self = this

            // VERIFICA SE O VALOR RECEBIDO É UM VALOR VALIDO
            if ([ '', null, undefined ].indexOf(value) !== -1 || [ '', null, undefined ].indexOf(value.cliente) !== -1) {
              value = { id: '', cliente: '', cnpj: '', clu: '' }
            }

            // ATUALIZA OS VALORES
            self.formulario.field.cliente.value = value.cliente
            self.formulario.field.cliente.valueRef = value.id

            // SETA O CODIGO DA LICENÇA RECEIDO
            self.formulario.field.codigo.value = value.clu

            // SETA O CNPJ RECEIBO
            self.formulario.field.documento.value = value.cnpj

            // SETA OS DADOS RECEBIDOS
            self.dados = value

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // INICIA A FUNÇÃO CALLBACK
            var callback = function (clu = null) {
              // VERIFICA SE A CLU FOI RECEBIDA
              if ([ '', null, undefined ].indexOf(clu) === -1) {
                // SETA A CLU DO CONTATO RECEBIDA
                self.formulario.field.codigo.value = clu

                // ATUALIZA A CLU RECEBIDA
                self.dados.clu = clu
              }

              // REALIZA O FOCUS NO CAMPO SOLICITADO
              self.regAteNovoAtendimentoRealizarFocusCampos('motivo')
  
              // CHAMA A FUNÇÃO PARA VERIFICAR QUAIS CAMPOS DEVE MOSTRAR
              self.regAteNovoAtendimentoVerificarCampos('todos')
            }

            // VERIFICA SE FOI ENCONTRADO UM CONTATO E SE ELE NÃO TEM A CLU, TENTA IDENTIFICAR A CLU
            if ([ '', null, undefined ].indexOf(value.id) === -1 && [ '', null, undefined ].indexOf(value.clu) !== -1 && self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 7 ], null, null, null, null, null, false) === true) {
              self.regAteNovoAtendimentoBuscaAtravesDoIdContato(value.id, callback)
            } else {
              callback()
            }
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteNovoAtendimentoBuscaFormaContato: function (self, callback = null, registros = [], total = null) {
        if (total === null || registros.length < total) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null, icone: null }, where: { f: 'status', o: '=', v: '1' }, order: { nome: 'asc' } }
  
          // FAZ A BUSCA NA API
          self.$store.state.comunicaAPI('/reg-atendimento/config/for-contato/get/', 'GET', queryGet, function (apiSuccess) {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA CARREGAR TODOS OS REGISTROS
            self.regAteNovoAtendimentoBuscaFormaContato(self, callback, registros, Number(apiSuccess.countAll))
          }, self.regAteNovoAtendimentoSetarStatusGeral)
        } else {
          // SETA OS REGISTROS RECEBIDOS
          self.formulario.field.forma.options = registros

          // SETA O VALOR INICIAL DO CAMPO
          if (self.formulario.field.forma.value === '') {
            self.formulario.field.forma.value = '3'
          }

          // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
          if (callback !== null) {
            callback()
          }
        }
      },
      regAteNovoAtendimentoBuscarStatus: function (self, callback = null) {
        // INICIA O QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null }, where: { f: 'status', o: '=', v: '1' } }

        // FAZ A BUSCA NA API
        self.$store.state.comunicaAPI('/reg-atendimento/config/status/get/', 'GET', queryGet, function (apiSuccess) {
          // SETA O VALOR RECEBIDO
          self.formulario.field.status.options = apiSuccess.data

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
          if (callback !== null) {
            callback()
          }
        }, self.regAteNovoAtendimentoSetarStatusGeral)
      },
      regAteNovoAtendimentoBuscarResponsavel: function (self, callback = null) {
        // SETA O VALOR RECEBIDO
        self.formulario.field.responsavel.options = self.$store.state.usuarios_reg_ate

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
        if (callback !== null) {
          callback()
        }
      },
      regAteNovoAtendimentoBuscarDados: function (self, callback = null) {
        // SETA A ROTA QUE DEVE CHAMAR
        var route = ''

        // SETA O METHOD QUE DEVE CHAMAR
        var method = 'GET'

        // INICIA A QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 10 }, where: { aAnd: [] } }

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        switch ((([ '', null, undefined, '0', 0 ].indexOf(self.cpntContatoId) === -1) + '_' + ([ '', null, undefined, '0', 0 ].indexOf(self.cpntClu) === -1) + '_' + (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 7 ], null, null, null, null, null, false) === true))) {
          case 'true_true_true':
          case 'false_true_true':
            // SETA A ROTA QUE DEVE CHAMAR
            route = '/subase/cli-rotinafacil/get'

            // SETA O METHOD
            method = 'POST'

            // SETA OS CAMPOS QUE DEVEM RETORNAR
            queryGet.field = { id_con_subase: { a: 'id' }, cliente: null, cnpj: null, clu: null }

            // SETA O FILTRO DA LICENÇA DE USO
            if ([ '', null, undefined, '0', 0 ].indexOf(self.cpntClu) === -1) {
              queryGet.where.aAnd.push({ f: 'clu', o: '=', v: self.cpntClu })
            }

            // SETA O FILTRO DA LICENÇA DE USO
            if ([ '', null, undefined, '0', 0 ].indexOf(self.cpntContatoId) === -1) {
              queryGet.where.aAnd.push({ f: 'id_con_subase', o: '=', v: self.cpntContatoId })
            }
            break

          case 'true_false_true':
          case 'true_false_false':
            // SETA A ROTA QUE DEVE CHAMAR
            route = '/contato/get'

            // SETA O METHOD
            method = 'POST'

            // SETA OS CAMPOS QUE DEVEM RETORNAR
            queryGet.field = { id: null, nome: { a: 'cliente' }, cnpj_cpf: { a: 'cnpj' }, pessoa: null }

            // SETA O WHERE NA TABELA
            queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

            // SETA O FILTRO DA LICENÇA DE USO
            if ([ '', null, undefined, '0', 0 ].indexOf(self.cpntContatoId) === -1) {
              queryGet.where.aAnd.push({ f: 'id', o: '=', v: self.cpntContatoId })
            }
            break
        }

        // VERIFICA S DEVE BUSCAR ALGUM REGISTRO
        if (route === '') {
          // SETA OS DADOS RECEBIDOS
          self.dados = {}

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA VERIFICAR QUAIS CAMPOS DEVE MOSTRAR
          self.regAteNovoAtendimentoVerificarCampos('todos', 0, callback, self)
        } else {
          // FAZ A COMUNICAÇÃO COM A API
          self.$store.state.comunicaAPI(route, method, queryGet, function (apiSuccess) {
            if (apiSuccess.data.length === 1) {
              // SETA OS DADOS RECEBIDOS
              self.formulario.field.cliente.onChange(apiSuccess.data[0], self.formulario.field.cliente.id)
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
  
              // EXECUTA A FUNÇÃO CALLBACK 
              if (callback !== null) {
                callback()
              }
            } else {
              // APRESENTA A MENSAGEM RETORNADA DA API
              self.$store.state.msgWarn('WEB [406]: Cadastro solicitado, não foi localizado.', 'warning')
  
              // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
              self.regAteNovoAtendimentoFechar(false)
            }
          }, self.regAteNovoAtendimentoSetarStatusGeral)
        }
      },
      regAteNovoAtendimentoVerificarCampos: function (campos, index = 0, callback = null, self = null) {
        // SETA A VARIAVEL SELF
        if (self === null) {
          self = this
        }

        // VERIFICA OS CAMPOS QUE DEVEM TRATAR
        switch (campos) {
          // PEGA TODOS OS CAMPOS SOLICITADOS
          case 'todos':
            // LIMPA O VETOR
            campos = []

            // SETA TODOS OS CAMPOS
            campos = campos.concat(Object.keys(self.formulario.field))

            // SETA TODOS BOTOES
            campos = campos.concat(Object.keys(self.formulario.buttons))
            break

          default:
            // CONVERTE A STRING E VETOR
            if (typeof campos === 'string') {
              campos = [ campos ]
            }
            break
        }

        // REMOVER VALORES DUPLICADOS
        campos = campos.filter((v, i, a) => v.indexOf('separador') === -1 && a.indexOf(v) === i)

        if ([ '', null, undefined ].indexOf(campos[index]) === -1) {
          // PEGA A CHAVE ENCONTRADA
          var chave = campos[index]

          // SETA A FUNÇÃO PARA REINICIAR O PROCESSO
          var restart = function () { self.regAteNovoAtendimentoVerificarCampos(campos, (index + 1), callback, self) }

          // VERIFICA A AÇÃO DE CADA CAMPO
          switch (chave) {
            case 'codigo':
              // VERIFICA SE DEVE MOSTRAR O CAMPO
              self.formulario.field[chave].mostrar = self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 7 ], null, null, null, null, null, false) === true

              // VERIFICA SE DEVE DESATIVAR O CAMPO
              self.formulario.field[chave].disabled = (([ '', null, undefined, '0', 0 ].indexOf(self.cpntClu) === -1 || [ '', null, undefined, '0', 0 ].indexOf(self.cpntContatoId) === -1)) === true

              // REINICIA O PROCESSO
              restart()
              break

            case 'documento':
              // VERIFICA A MASCARA E O NOME DO CAMPO QUE DEVE MOSTRAR
              switch ([ '', null, undefined, 'j' ].indexOf(self.dados.pessoa) === -1) {
                case true:
                  self.formulario.field[chave].nome = 'CPF'
                  self.formulario.field[chave].mask = 'cpf'
                  break

                default:
                  self.formulario.field[chave].nome = 'CNPJ'
                  self.formulario.field[chave].mask = 'cnpj'
                  break
              }

              // // VERIFICA SE DEVE DESATIVAR O CAMPO
              self.formulario.field[chave].disabled = (([ '', null, undefined, '0', 0 ].indexOf(self.cpntClu) === -1 || [ '', null, undefined, '0', 0 ].indexOf(self.cpntContatoId) === -1)) === true

              // REINICIA O PROCESSO
              restart()
              break

            case 'responsavel':
              // SETA O ID DO RESPONSAVEL
              if ([ '', null, undefined ].indexOf(self.formulario.field[chave].value) !== -1) {
                self.formulario.field[chave].value = self.$store.state.usuario.id_usu
              }

              // VERIFICA SE DEVE DESATIVAR O CAMPO
              self.formulario.field[chave].mostrar = [ '', null, undefined ].indexOf(self.cpntAssuntoId) !== -1

              // REINICIA O PROCESSO
              restart()
              break

            case 'status':
              // SETA O ID DO STATUS
              if ([ '', null, undefined ].indexOf(self.formulario.field[chave].value) !== -1) {
                self.formulario.field[chave].value = '1'
              }

              // VERIFICA SE DEVE DESATIVAR O CAMPO
              self.formulario.field[chave].mostrar = [ '', null, undefined ].indexOf(self.cpntAssuntoId) !== -1

              // REINICIA O PROCESSO
              restart()
              break

            case 'cliente':
              // VERIFICA SE DEVE DESATIVAR O CAMPO
              self.formulario.field[chave].disabled = ([ '', null, undefined, '0', 0 ].indexOf(this.cpntClu) === -1 || [ '', null, undefined, '0', 0 ].indexOf(this.cpntContatoId) === -1)

              // REINICIA O PROCESSO
              restart()
              break

            case 'atendimento':
              // VERIFICA SE DEVE DESATIVAR O CAMPO
              self.formulario.buttons[chave].mostrar = [ '', null, undefined ].indexOf(self.cpntAssuntoId) !== -1

              // REINICIA O PROCESSO
              restart()
              break

            case 'direto':
            case 'link':
              // VERIFICA SE DEVE MOSTRAR O CAMPO
              self.formulario.buttons[chave].mostrar = [ '', null, undefined ].indexOf(self.dados.clu) === -1 && self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 7 ], null, [ 18 ], null, [ 218 ], null, false) === true

              // REINICIA O PROCESSO
              restart()
              break

            // REINICIA O PROCESSO
            default:
              restart()
              break
          }
        } else {
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          if (callback !== null) {
            callback()
          }
        }
      },
      regAteNovoAtendimentoSalvarComentario: function (id, assuntoId = null) {
        if (this.formulario.field.motivo.value.length <= 15) {
          // APRESETNA A EMSANGEM DE ERRO
          this.$store.state.msgWarn('WEB [406]: Para continuar é necessario preencher um motivo com mais de 15 caracteres para continuar', 'warning')

          // SETA FOCUS NO CAMPO
          this.regAteNovoAtendimentoRealizarFocusCampos('motivo')
        } else {
          var self = this

          // SETA O STATUS DOS BUTTONS
          self.regAteNovoAtendimentoSetarStatusButtons('carregando')

          // PEGA A AÇÃO SOLICITADA
          var acao = id.split('--')[1]

          // INICIANDO O FORMULARIO QUE SERÁ ENVIADO PARA API
          var formData = {}

          // VERIFICA SE DEVE INICIAR UM NOVO ASSUNTO OU ADICIONAR UMA MENSAGEM
          if ([ 'direto', 'link' ].indexOf(acao) !== -1) {
            // SETA OS DADOS DA MENAGEM
            formData.comentario = { acao: 'CONECTAR_SUPORTE_RF', tipo: acao, usuarioId: self.$store.state.usuario.id, usuarioNome: self.$store.state.usuario.usuario }

            // SETA O MOTIVO DA CONEXÃO NO SUPORTERF
            formData.comentario.motivo = self.formulario.field.motivo.value

            // CONVERTE O VALOR EM STRING
            formData.comentario = JSON.stringify(formData.comentario)
          } else {
            formData.comentario = self.formulario.field.motivo.value
          }

          // SETA O ID DO ASSUNTO EXISTENTE
          if ([ '', null, undefined ].indexOf(self.cpntAssuntoId) === -1 || [ '', null, undefined ].indexOf(assuntoId) === -1) {
            formData.id_reg_ate_pai = [ '', null, undefined ].indexOf(assuntoId) !== -1 ? self.cpntAssuntoId : assuntoId
          }

          // VERIFICA SE É UM NOVO ASSUNTO
          if ([ '', null, undefined ].indexOf(formData.id_reg_ate_pai) !== -1) {
            // SETA O ID DO CONTATO DESEJADO
            formData.id_contato = self.formulario.field.cliente.valueRef

            // SETA O RESPONSAVEL
            formData.responsavel_user = self.formulario.field.responsavel.value

            // SETA O STATUS
            formData.id_status = self.formulario.field.status.value

            // SETA O CODIGO DA LICENÇA DE USO
            if ([ '', null, undefined ].indexOf(self.dados.clu) === -1) {
              formData.clu = self.dados.clu
            }
          }

          // SETA A FORMA DE CONTATO
          formData.id_forma_contato = self.formulario.field.forma.value

          // CONVERTE OS VALORES RECEIBODS PARA LOT
          formData = { lot: [ formData ] }
  
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          self.$store.state.comunicaAPI('/reg-atendimento', 'POST', formData, function (apiSuccess) {
            // SETA O RETORNO RECEBIDO
            var retorno = apiSuccess.lot[0]

            // VERIFICA O CODIGO RECEBIDO
            switch (retorno.code) {
              case '200':
                if ([ '', null, undefined ].indexOf(retorno.ws) !== -1 || retorno.ws.code !== '200') {
                  // INICIA A MENSAGEM
                  var erroWS = { cod: '500', loc: 'WS', err: '' }
    
                  // SETA O CODIGO RECEBIDO
                  if ([ '', null, undefined ].indexOf(retorno.ws) === -1 && [ '', null, undefined ].indexOf(retorno.ws.code) !== -1) {
                    erroWS.cod += retorno.ws.code
                  }
    
                  // SETA A MENSAGEM RECEBIDA
                  erroWS.err += ([ '', null, undefined ].indexOf(retorno.ws) === -1 && [ '', null, undefined ].indexOf(retorno.ws.message) === -1) === true ? retorno.ws.message : 'OPS! Não foi possível enviar a mensagem neste momento aos outros usuários. Por favor entre em contato com nosso suporte.'

                  // APRESENTA A MENASGEM DE ERRO
                  self.$store.state.msgWarn(erroWS.loc + ' [' + erroWS.cod + ']: ' + erroWS.err, 'danger')
                }

                // SETA O ID DO ASSUNTO EXISTENTE
                if ([ '', null, undefined ].indexOf(self.cpntAssuntoId) === -1 || [ '', null, undefined ].indexOf(assuntoId) === -1) {
                  assuntoId = [ '', null, undefined ].indexOf(assuntoId) !== -1 ? self.cpntAssuntoId : assuntoId
                }

                // VERIFICA SE DEVE INSERIR UM COMENTARIO DENTRO DO NOVO ASSUNTO
                if ([ '', null, undefined ].indexOf(assuntoId) !== -1 && [ 'direto', 'link' ].indexOf(acao) !== -1) {
                  self.regAteNovoAtendimentoSalvarComentario(id, apiSuccess.lot[0].ref.id)
                } else {
                  // PEGA O ASSUNTO QUE DEVE ADICIONAR
                  assuntoId = [ '', null, undefined ].indexOf(assuntoId) === -1 ? assuntoId : apiSuccess.lot[0].ref.id
  
                  // SETA O CALLBACK
                  var callback = function () {
                    // VERIFICA SE O ID DO REGISTRO FOI RECEBIDO
                    if ([ '', null, undefined ].indexOf(assuntoId) === -1) {
                      // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA ABRIR O CHAT
                      var formData = { tipo: 'abrir', contato: self.formulario.field.cliente.valueRef, assunto: assuntoId, favorito: true }

                      // SETA O ID DA MENSAGEM QUE DEVE DAR FOCUS
                      if (apiSuccess.lot[0].ref.id !== assuntoId) {
                        formData.mensagem = apiSuccess.lot[0].ref.id
                      }
  
                      // SETA O REGISTRO DE ATENDIMENTO
                      self.$store.commit('SET_REG_ATENDIMENTO', formData)
                    }
  
                    // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
                    self.regAteNovoAtendimentoFechar(true, self.formulario.field.cliente.valueRef, assuntoId)
                  }
  
                  // VERIFICA SE DEVE CONECTAR NO SUPORTERF
                  switch (acao) {
                    case 'link':
                    case 'direto':
                      self.regAteNovoAtendimentoGerarLinkSuporteRF(assuntoId, acao, callback)
                      break
  
                    default:
                      callback()
                      break
                  }
                }
                break

              default:
                self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', retorno.message, retorno.code, self.formulario.field, true, self.regAteNovoAtendimentoTratarRetornoValidacao)
                break
            }

          }, self.regAteNovoAtendimentoSetarStatusButtons, function (apiValid, apiStatus) {
            self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, self.formulario.field, true, self.regAteNovoAtendimentoTratarRetornoValidacao)
          })
        }
      },
      regAteNovoAtendimentoSetarStatusButtons: function (status) {
        if ([ '', 'carregando' ].indexOf(status) !== -1) {
          // SETA O STATUS DO BUTTON
          this.formulario.buttons.atendimento.status = status
          this.formulario.buttons.direto.status = status
          this.formulario.buttons.link.status = status
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        } else {
          this.regAteNovoAtendimentoSetarStatusGeral(status)
        }
      },
      regAteNovoAtendimentoTratarRetornoValidacao: function (fields = {}, focus) {
        // SETA OS CAMPOS RECEBIDOS COM ERRO NO FORMULARIO
        if ([ '', null, undefined ].indexOf(fields) === -1 && Object.keys(fields).length >= 1) {
          this.formulario.field = fields
        }

        // SETA FOCUS NO CAMPO SOLICITADO
        if ([ '', null, undefined ].indexOf(focus) === -1) {
          this.regAteNovoAtendimentoRealizarFocusCampos(focus)
        }

        // SETA O STATUS DOS BUTTONS
        this.regAteNovoAtendimentoSetarStatusButtons('')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteNovoAtendimentoGerarLinkSuporteRF: function (assuntoId, acao, callback) {
        var self = this

        // CONVERTE OS VALORES RECEIBODS PARA LOT
        var queryGet = self.formulario.field.codigo.value + '/' + assuntoId

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        self.$store.state.comunicaAPI('/subase/painel/suporterf/get/', 'GET', queryGet, function (apiSuccess) {
          if ([ '', null, undefined ].indexOf(apiSuccess.data) === -1) {
            switch (acao) {
              case 'direto':
                window.open(apiSuccess.data, '_blank')
                break
            
              case 'link':
                self.$store.commit('FUN_COPIAR_VALOR', { valor: apiSuccess.data, mensagem: 'WEB [200]: Link de acesso ao SuporteRF gerado com sucesso e copiado para a área de transferência.' })
                break

              default:
                // APRESENTA A MENSAGEM RETORNADA DA API
                self.$store.state.msgWarn('WEB [406]: Erro ao identificar acao para o link do SuporteRF recebido.', 'warning')
                break
            }
          } else {
            self.$store.state.msgWarn('WEB [406]: Erro ao gerar link de acesso SuporteRF.', 'warning')
          }

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }, self.regAteNovoAtendimentoSetarStatusGeral)
      },
      regAteNovoAtendimentoFinalizar: function (self, callback = null) {
        // SETA O STATUS DA TELA
        self.regAteNovoAtendimentoSetarStatusGeral('')

        // SETA O FOCUS NO CAMPO INICIAL
        self.regAteNovoAtendimentoRealizarFocusCampos([ '', null, undefined ].indexOf(self.formulario.field.cliente.value) === -1 ? 'motivo' : 'cliente')

        // EXECUTA A FUNÇÃO CALLBACK 
        if (callback !== null) {
          callback()
        }
      },
      regAteNovoAtendimentoRealizarFocusCampos: function (campo, tentativa = 0) {
        if ([ '', null, undefined ].indexOf(campo) === -1) {
          var self = this

          setTimeout(function () {
            if ([ '', null, undefined ].indexOf(self.$refs[campo]) === -1) {
              if ([ '', null, undefined ].indexOf(self.$refs[campo][0].$refs) === -1 && Object.keys(self.$refs[campo][0].$refs).length === 1 && [ '', null, undefined ].indexOf(self.$refs[campo][0].$refs[Object.keys(self.$refs[campo][0].$refs)[0]].onFocusField) === -1) {
                self.$refs[campo][0].$refs[Object.keys(self.$refs[campo][0].$refs)[0]].onFocusField()
              } else if (tentativa <= 10) {
                self.regAteNovoAtendimentoRealizarFocusCampos(campo, (tentativa + 1))
              }
            } else if (tentativa <= 10) {
              self.regAteNovoAtendimentoRealizarFocusCampos(campo, (tentativa + 1))
            }
          }, (tentativa === 0 ? 0 : 200))
        }
      },
      regAteNovoAtendimentoBuscaAtravesDoIdContato: function (id, callback) {
        var self = this

        // INICIA A QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 10 } }

        // SETA OS CAMPOS QUE DEVEM RETORNAR
        queryGet.field = { clu: null, cliente: null }

        // BUSCA A LICENÇA DE USO PARA ESSE ID
        queryGet.where = { f: 'id_con_subase', o: '=', v: id }

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        self.$store.state.comunicaAPI('/subase/cli-rotinafacil/get', 'POST', queryGet, function (apiSuccess) {
          if (apiSuccess.data.length === 1) {
            callback(apiSuccess.data[0].clu)
          } else {
            callback()
          }
        }, self.regAteNovoAtendimentoSetarStatusGeral)
      },
      regAteNovoAtendimentoBuscaAtravesDosDadosDigitados: function (id) {
        var self = this

        // PEGA O NOME DO CAMPO
        var index = id.split('--')[1]

        // ATIVA OS CAMPOS NOVAMENTE
        self.formulario.field.codigo.disabled = true
        self.formulario.field.documento.disabled = true

        // INICIA A QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 10 } }

        // SETA OS CAMPOS QUE DEVEM RETORNAR
        queryGet.field = { id_con_subase: { a: 'id' }, cliente: null, cnpj: null, clu: null }

        // VERIFICA O WHERE QUE DEVE SER FEITO
        switch (index) {
          case 'codigo':
            queryGet.where = { f: 'clu', o: '=', v: self.formulario.field.codigo.value }
            break

          case 'documento':
            queryGet.where = { f: 'cnpj', o: '=', v: self.formulario.field.documento.value }
            break
        }

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        self.$store.state.comunicaAPI('/subase/cli-rotinafacil/get', 'POST', queryGet, function (apiSuccess) {
          if (apiSuccess.data.length === 0) {
            // APRESETNA A EMSANGEM DE ERRO
            self.$store.state.msgWarn('WEB [406]: Licença de uso não localizada, por favor tente novamente.', 'warning')

            // CHAMA A FUNÇÃO PARA LIMPAR OS CAMPOS
            self.formulario.field.cliente.onChange('', self.formulario.field.cliente.id)
          } else if (apiSuccess.data.length === 1) {
            // ATIVA OS CAMPOS NOVAMENTE
            self.formulario.field.codigo.disabled = false
            self.formulario.field.documento.disabled = false

            // CHAMA A FUNÇÃO PARA BUSCAR OS DADOS
            self.formulario.field.cliente.onChange(apiSuccess.data[0], self.formulario.field.cliente.id)
          } else {
            // APRESETNA A EMSANGEM DE ERRO
            self.$store.state.msgWarn('WEB [500]: Erro mais de uma registro encontrado, por favor utilize o campo CLiente para procurar o contato desejado.', 'danger')

            // CHAMA A FUNÇÃO PARA LIMPAR OS CAMPOS
            self.formulario.field.cliente.onChange('', self.formulario.field.cliente.id)
          }
        }, self.regAteNovoAtendimentoSetarStatusGeral)
      }
    }
  }
</script>
